import { Router } from "@remix-run/router";
import routerReparateur from "./routes/reparateur/router";
import routerSav from "./routes/gestion-sav/router";
import routerAdmin from "./routes/admin/router";
import routerDeclarationSinistre from "./routes/declaration-sinistre/router";
import { RouterProvider } from "react-router-dom";
import { useConfirmStore } from "./Components/Confirm/useConfirmStore";
import ConfirmDialog from "./Components/Confirm/ConfirmDialog";
import routerSatisfaction from "./routes/satisfaction-beneficiaire/router";
import { homeDipropneuRouter } from "./routes/home-dipropneu/router";
import { souscriptionFactureRouter } from "./routes/souscription-facture/router";
import { declarationSorRouter } from "./routes/declaration-sor/router";
import { tireWarrantyRouter } from "./routes/tire-warranty/router";
import { Toaster } from 'sonner';
import { getRouterName } from "./config/domainConfigLoader";
import { StrictMode } from "react";

// Router mapping using direct strings from domain-config.json
const routers: Record<string, Router> = {
  'reparateur': routerReparateur,
  'sav': routerSav,
  'admin': routerAdmin,
  'declaration-sinistre': routerDeclarationSinistre,
  'satisfaction': routerSatisfaction,
  'home-dipropneu': homeDipropneuRouter,
  'souscription-facture': souscriptionFactureRouter,
  'declaration-sor': declarationSorRouter,
  'tire-warranty': tireWarrantyRouter
};

// Get router based on hostname using centralized config
function getRouterForHostname(hostname: string): Router {
  console.log('hostname', hostname);

  // Utilise la configuration centralisée directement
  const routerName = getRouterName(hostname);
  console.log('routerName from config', routerName);

  // Accès direct sans conversion - beaucoup plus simple !
  const router = routers[routerName] || routers['sav'];

  console.log('selected router for name', routerName);
  return router;
}

const router: Router = getRouterForHostname(window.location.hostname);

export default function App() {
  const { isOpen, title, text, buttons, resolve } = useConfirmStore();

  return (
    <StrictMode>
      <Toaster closeButton />
      <RouterProvider router={router} />
      {isOpen && (
        <ConfirmDialog
          title={title}
          text={text}
          buttons={buttons}
          resolve={resolve}
        />
      )}
    </StrictMode>
  );
}